<template>
  <div
    class="h-screen w-full flex flex-col justify-center items-center bg-primary"
  >
    <h1 class="text-9xl font-extrabold text-white tracking-widest">404</h1>
    <div class="bg-accent px-2 text-sm rounded rotate-12 absolute text-white">
      Page Not Found
    </div>
    <button class="mt-5">
      <router-link
        class="
          relative
          inline-block
          text-sm
          font-medium
          text-accent
          rounded-xl
          group
          active:text-accent
          border border-accent
          px-8
          py-3
          hover:bg-accent hover:text-white
          transition-default
        "
        :to="{ name: 'Homepage' }"
        >Go Home</router-link
      >
    </button>
  </div>
</template>
<script>
export default {
  name: "PageNotFound",
};
</script>
<style>
</style>